import { render, staticRenderFns } from "./IconChannel.vue?vue&type=template&id=57f6220e&scoped=true&"
import script from "./IconChannel.vue?vue&type=script&lang=js&"
export * from "./IconChannel.vue?vue&type=script&lang=js&"
import style0 from "./IconChannel.vue?vue&type=style&index=0&id=57f6220e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f6220e",
  null
  
)

export default component.exports